// extracted by mini-css-extract-plugin
export var leftAlign = "_1v-2";
export var popper = "_1v-0";
export var subtitle = "_1v-1";